import axios from '../helpers/Axios'

export default {

  async getMaintenance() {
    return await axios.get("/system");
  },

}
